

export function filterSpeakersWithProgramSessions(speaker) {
    return speaker.program_item_ids?.length > 0
}